import React, { useEffect, useState } from "react";
import Select from "react-select";
import CustomButton from "../Utility/Button";
import { DashboardBox } from "../Utility/DashboardBox";
import ReactQuill from "react-quill"; // ES6
import FileUpload from "../Utility/FileUpload";
import QuillEditor from "../../utils/QuillEditor";
import { useSelector, useDispatch } from "react-redux";
import { BLOGCATEGORYGet } from "../../redux/actions/BlogCategory/BlogCategory.actions";
import { toastError } from "../../utils/toastUtils";

import {
  blogAdd,
  BLOGGet,
  blogUpdate,
  SetBlogObj,
  BLOGDelete,
} from "../../redux/actions/Blog/Blog.actions";

import { tagGet } from "../../redux/actions/Tag/Tag.actions";

function AddBlog() {
  let dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState({});
  const [tags, setTags] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeyword, setMetaKeyword] = useState("");

  const [image, setImage] = useState("");
  const [prevBlogId, setPrevBlogId] = useState(null);
  const [publish, setPublish] = useState(false);
  const [isUpdateBlog, setIsUpdateBlog] = useState(false);
  // console.log(category, "categorydf");
  // const options = [
  //   { value: "chocolate", label: "Chocolate" },
  //   { value: "strawberry", label: "Strawberry" },
  //   { value: "vanilla", label: "Vanilla" },
  //   { value: "vanilla1", label: "Vanillaone" },
  //   { value: "vanilla2", label: "Vanillatwo" },
  // ];
  const options = [];
  const blogObj = useSelector((state) => state.blog.BLOGObj);
  const blogCategoryArr = useSelector(
    (state) => state.blogCategory.blogCategories
  );
  if (blogCategoryArr) {
    for (let el of blogCategoryArr) {
      options.push({ value: el.name, label: el.name });
    }
  }
  // console.log(blogCategoryArr, "in add blog here");
  // console.log(blogObj, "blogObj  34");
  useEffect(() => {
    if (blogObj) {
      setTitle(blogObj?.title);
      setSlug(blogObj?.slug);
      setDescription(blogObj?.description);
      setImage(blogObj?.image);
      setTags(blogObj?.tags)
      setPublish(blogObj.publish);
      setMetaDescription(blogObj.metaDescription);
      setMetaKeyword(blogObj?.metaKeyword)
      setPublish(blogObj.publish);
      setPrevBlogId(blogObj?._id);
      if(blogObj?.blogCategoryId){
         let categoryArr =blogCategoryArr && blogCategoryArr.filter(el=>el._id ==blogObj?.blogCategoryId);
          console.log(categoryArr,"categoryArr")
          if(categoryArr  && categoryArr?.length && categoryArr.length == 1){
            setCategory({ value: categoryArr[0]?.name, label: categoryArr[0]?.name });
          }

      }

      setIsUpdateBlog(true);
    }
  }, [blogObj]);

  const handleBlogCategoryGet = () => {
    dispatch(BLOGCATEGORYGet());
  };
  useEffect(() => {
    handleBlogCategoryGet();
  }, []);
  // const handleTagGet = () => {
  //   dispatch(tagGet());
  // };
  // useEffect(() => {
  //   handleTagGet();
  // }, []);
  const handleSubmit = (e) => {
    e.preventDefault();
console.log(category.value)
    if(`${title}` == ''){
      toastError('Title is mandatory');
      return
    }

    if(`${slug}` == ''){
      toastError('Slug is mandatory');
      return
    }

    if(`${description}` == ''){
      toastError('Description is mandatory');
      return
    }

    if(`${image}` == ''){
      toastError('image is mandatory');
      return
    }
    if(`${tags}` == ''){
      toastError('tags is mandatory');
      return
    }

    
    if(category.value== undefined){
      toastError('category is mandatory');
      return
    }

    let obj = {
      title,
      slug,
      description,
      tags,
      category: category.value,
      image,
      publish,
      metaKeyword,
      metaDescription
    };

    if (blogObj?._id) {
      dispatch(blogUpdate(prevBlogId, obj));
    } else {
      dispatch(blogAdd(obj));
    }
  };

  const handleFileSet = (value) => {
    setImage(value);
  };
  return (
    <main>
      <section className="product-category" style={{ minHeight: "75vh" }}>
        <div className="container-fluid p-0">
          <form action="#" className="form">
            <h5 className="blue-1 mb-4">
              {isUpdateBlog ? "Update" : "Add New "} Blog
            </h5>
            <div className="row gy-4 gy-xxl-0">
              <div className="col-12 col-xxl-8">
                <DashboardBox>
                  <div className="row">
                    <h5 className="blue-1 mb-4">Blog Info</h5>
                    <div className="col-12 mb-3">
                      <label>
                        TITLE <span className="red">*</span>
                      </label>

                      {/* <div className="col-12 mb-3">
                    <label className="blue-1 fs-12">
                      CATEGORY NAME<span className="red">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={categoryName}
                      onChange={(event) => setCategoryName(event.target.value)}
                    />
                  </div> */}
                      <input
                        type="text"
                        className="form-control"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                      {/* {title} */}
                    </div>
                    <div className="col-12 mb-3">
                      <label>
                        SLUG<span className="red">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={slug}
                        onChange={(e) => setSlug(e.target.value)}
                      />
                    </div>
                    <div className="col-12">
                      <label>
                        DESCRIPTION<span className="red">*</span>
                      </label>
                      <ReactQuill
                        theme="snow"
                        value={description}
                        onChange={(e) => setDescription(e)}
                      />
                      {/* <ReactQuill /> */}
                      {/* <QuillEditor theme="snow"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)} /> */}
                    </div>

                    <div className="col-12 mb-3">
                      <label>
                        Meta Keyword<span className="red">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={metaKeyword}
                        onChange={(e) => setMetaKeyword(e.target.value)}
                      />
                    </div>

                    <div className="col-12 mb-3">
                      <label>
                        Meta Description<span className="red">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={metaDescription}
                        onChange={(e) => setMetaDescription(e.target.value)}
                      />
                    </div>
                  </div>
                </DashboardBox>
              </div>
              <div className="col-12 col-xxl-4">
                <DashboardBox>
                  <div className="row">
                    <h5 className="blue-1 mb-4">Basic Info</h5>
                    <div className="col-12 mb-3">
                      <label>
                        CATEGORY<span className="red">*</span>
                      </label>
                      {/* <Select options={options} /> */}
                      <Select
                        options={options}
                        value={category}
                        onChange={(e) => setCategory(e)}
                      />
                    </div>
                    <div className="col-12 mb-3">
                      <label>
                        Tags (Comma Separated)<span className="red">*</span>
                      </label>
                      <input
                        value={tags}
                        onChange={(event) => setTags(event.target.value)}
                        type="text"
                        className="form-control"
                      />
                      {/* <Select
                        options={options}
                        isMulti
                        onChange={(e) => setTags(e)}
                      /> */}

                      <div className="form-text fs-12 blue-1">
                        Suggested Tags
                      </div>
                    </div>
                    <div className="col-12 mb-3">
                      <label>
                        Image(1000x500)px<span className="red">*</span>
                      </label>
                      <FileUpload onFileChange={handleFileSet} />
                    </div>
                    {/* 
                    <div className="col-12">
                      <label>Status</label>
                      <div className="form-check form-check-inline d-flex align-items-center">
                        <input checked={status} onChange={() => setStatus(!status)} className="form-check-input" type="checkbox" name="category-status" value="option1" id="active-banner" />
                        <label className="form-check-label fs-14" htmlFor="active-banner">
                          Active
                        </label>
                      </div>
                    </div>
                     */}

                    <div className="col-12 mb-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="category-status"
                          value="option1"
                          id="publish-checkbox"
                          checked={publish}
                          onChange={() => setPublish(!publish)}
                        />
                        <label
                          className="form-check-label fs-14"
                          htmlFor="publish-checkbox"
                        >
                          Publish
                        </label>
                        {/* <input checked={publish} onChange={() => setPublish(!publish)} className="form-check-input" type="checkbox" name="category-status" value="option1" id="active-banner" /> */}
                      </div>
                    </div>
                    <div className="col-12">
                      <CustomButton
                        isBtn
                        iconName="fa-solid fa-check"
                        btnName="Save"
                        ClickEvent={handleSubmit}
                      />
                    </div>
                  </div>
                </DashboardBox>
              </div>
            </div>
          </form>
        </div>
      </section>
    </main>
  );
}

export default AddBlog;
